<template>
    <header class="main-header">
        <div class="main-header__logo-wrap">
            <router-link :to="{ name: 'Home', params: {lang: currentLangName()}}">
                <img src="@/assets/images/brand/univer-logo.svg" class="img-fluid" alt=""  />
            </router-link>
        </div>
        <div id="header-nav" class="navbar navbar-expand-lg">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-outer-wrap" >
                <span class="navbar-toggler-icon"></span>
            </button>
            <div id="navbar-outer-wrap" class="collapse navbar-collapse">
                <div class="navbar-collapse__inner">                                                      
                    <Navbar />                                    
                    <div class="main-header__search-wrap" v-if="appVersion!='v1'">
                        <Search />
                        <LanguageSelector /> 
                    </div>
                </div>
            </div>
        </div>
        <div class="main-header__search-wrap--mobile">
            <div class="search--mobile-btn" @click="showMobileSearch()"></div>
            <Search />
        </div>
    </header>
</template>

<script>
import Navbar from '@/components/layoutComponents/Navbar.vue'
import Search from '@/components/layoutComponents/Search.vue'
import LanguageSelector from '@/components/layoutComponents/LanguageSelector.vue'
import $ from "jquery"

export default {
    data(){
        return{
            appVersion: 'v2'
        }
    },
    components:{
        Navbar,
        Search,
        LanguageSelector
    },
    created(){
        window.addEventListener("resize", this.closeHeadMenu);
    },
    destroyed() {
        window.removeEventListener("resize", this.closeHeadMenu);
    },
    watch:{
        $route: function(){                        
            this.closeHeadMenu()
        },
   },
    methods:{
        closeHeadMenu(){
            $('#navbar-outer-wrap').collapse('hide')
        },
        showMobileSearch(){
            let e = event.target
            
            $(e).toggleClass('opened')
            $('.main-header__search-wrap--mobile').find('.search').toggleClass('show')
            $('.main-header').toggleClass('width-shadow')
        }
    }   
}
</script>